const GIT_ERROR_CODES = {
  PRIVATE_REPO_CONNECTIONS_LIMIT_REACHED: "AE-GIT-4043",
  PUSH_FAILED_REMOTE_COUNTERPART_IS_AHEAD: "AE-GIT-4048",
};

export default GIT_ERROR_CODES;
